export default __webpack_public_path__ + "static/media/iphone-x.ba5bfe17.png";